import { useTranslation } from 'react-i18next';


import "../styles/NewsTabComponent.css"; 

const NewsTabComponent = ({ news }) => {

    const {t} = useTranslation();

    return (
        <div className="news-tab-container">
            <h2 className="news-tab-title">{t("news_title")}</h2>
            <div className='news-tab-articles'>
                {news.map((article, index) => (
                    <div key={index} className="news-article">
                        <a href={article.url} className="news-article-link">
                            {article.link_name}
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );  

};

export default NewsTabComponent;
